import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="block-copy-paste"
export default class extends Controller {
  static values = {
    blockCut: { type: Boolean, default: false },
    blockSelectAll: { type: Boolean, default: false }
  }

  connect() {
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    this.boundHandleContextMenu = this.handleContextMenu.bind(this)
    this.boundHandlePaste = this.handlePaste.bind(this)
    this.boundHandleCopy = this.handleCopy.bind(this)
    this.boundHandleDragOver = this.handleDragOver.bind(this)
    this.boundHandleDrop = this.handleDrop.bind(this)
    this.boundHandleBeforeInput = this.handleBeforeInput.bind(this)

    this.element.addEventListener('keydown', this.boundHandleKeydown)
    this.element.addEventListener('contextmenu', this.boundHandleContextMenu)
    this.element.addEventListener('paste', this.boundHandlePaste)
    this.element.addEventListener('copy', this.boundHandleCopy)
    this.element.addEventListener('dragover', this.boundHandleDragOver)
    this.element.addEventListener('drop', this.boundHandleDrop)
    this.element.addEventListener('beforeinput', this.boundHandleBeforeInput)
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.boundHandleKeydown)
    this.element.removeEventListener('contextmenu', this.boundHandleContextMenu)
    this.element.removeEventListener('paste', this.boundHandlePaste)
    this.element.removeEventListener('copy', this.boundHandleCopy)
    this.element.removeEventListener('dragover', this.boundHandleDragOver)
    this.element.removeEventListener('drop', this.boundHandleDrop)
    this.element.removeEventListener('beforeinput', this.boundHandleBeforeInput)
  }

  handleKeydown(event) {
    const ctrlOrCmd = event.ctrlKey || event.metaKey

    if (ctrlOrCmd) {
      const blockedKeys = ['c', 'v']

      if (this.blockCutValue) blockedKeys.push('x')
      if (this.blockSelectAllValue) blockedKeys.push('a')

      if (blockedKeys.includes(event.key.toLowerCase())) {
        event.preventDefault()
        event.stopPropagation()
        return false
      }
    }
  }

  handleContextMenu(event) {
    event.preventDefault()
    return false
  }

  handlePaste(event) {
    event.preventDefault()
    return false
  }

  handleCopy(event) {
    event.preventDefault()
    return false
  }

  handleDragOver(event) {
    event.preventDefault()
    return false
  }

  handleDrop(event) {
    event.preventDefault()
    event.stopPropagation()
    return false
  }

  handleBeforeInput(event) {
    if (['insertFromPaste', 'insertFromDrop'].includes(event.inputType)) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }
  }
}
